import { on } from "@ngrx/store";

import { JobStatusDropdownActions } from "../../job-header/job-status-dropdown/job-status-dropdown.actions";
import { JobToolState } from "../../job-tool.reducer";

import { JobFormActionButtonActions } from "../job-form-action-button/job-form-action-button.actions";

import { CloseJobComponentActions } from "./close-job-component.actions";

export const closeJobComponentReducers = [
  on(
    JobStatusDropdownActions.closureReasonMenuItemSelected,
    CloseJobComponentActions.closureReasonSelected,
    (state: JobToolState, { closedReason }): JobToolState => {
      return {
        ...state,
        closedReason,
      }
    },
  ),
  on(
    CloseJobComponentActions.exitDialogButtonClicked,
    CloseJobComponentActions.closeJobSuccess,
    JobFormActionButtonActions.updateJobSuccess,
    (state: JobToolState): JobToolState => {
      return {
        ...state,
        closedReason: undefined,
      }
    },
  ),
  on(
    CloseJobComponentActions.dialogPrompted,
    (state: JobToolState, { promptedBy }): JobToolState => {
      return {
        ...state,
        closedReasonsDialogPromptedBy: promptedBy,
      }
    },
  ),
];
